import { I18n } from 'i18n';
import { Button } from 'antd';
import { useState } from 'react';
import { Toast } from 'components';
import { useHistory } from 'react-router-dom';
import { WaterTurn } from 'apollo/configuration';

export function Turn({ _id, power_status, current_status }) {
  const history = useHistory();
  const [isLoading, setLoading] = useState(false);

  const handleChange = async (e) => {
    setLoading(true);

    const { data, error, message } = await WaterTurn({ _id });

    if (error) {
      Toast.error({ key: 'error-save-waterpump', message: I18n(message, true) });
    } else if (data) {
      history.push('/water-quality/motor-pumps/table');
    }

    setLoading(false);
  };

  return (
    <Button
      loading={isLoading}
      disabled={current_status}
      type={power_status ? 'primary' : 'dashed'}
      size="middle"
      onClick={(e) => handleChange(e)}
    >
      {power_status ? `${I18n('turn_off', true)}` : `${I18n('turn_on', true)}`}
    </Button>
  );
}
